import img16a from '../../../assets/gallery/16a/16a-01-HOME_Camouflage2-2016-1524x3048mm-oleo-sobre-madera.jpg';
import img16b from '../../../assets/gallery/16a/16a-02_ST-2016-2032x3175mm-oleo-sobre-madera.jpg';
import img16c from '../../../assets/gallery/16a/16a-03_ST-2016-2032x3175mm-oleo-sobre-madera.jpg';
import img16d from '../../../assets/gallery/16a/16a-04_ST-2016-2032x3175mm-oleo-sobre-madera.jpg';
import img16e from '../../../assets/gallery/16a/16a-05_Camouflage1-2016-1524x3048mm-oleo-sobre-madera.jpg';

export const dataImages = [
  {
    id: 1,
    title: "152,4 x 304,8 cm",
    dimensions: "",
    pictureSrc: img16a,
    description: "2016",
    orientation: "h"
  },
  {
    id: 2,
    title: "",
    dimensions: "203,2 x3 317,5 cm",
    pictureSrc: img16b,
    description: "2016",
    orientation: "h"
  },
  {
    id: 3,
    title: "",
    dimensions: "203,2 x3 317,5 cm",
    pictureSrc: img16c,
    description: "2016",
    orientation: "h"
  },
  {
    id: 4,
    title: "",
    dimensions: "203,2 x3 317,5 cm",
    pictureSrc: img16d,
    description: "2016",
    orientation: "h"
  },
  // {
  //   id: 5,
  //   title: "",
  //   dimensions: "152,4 x 304,8 cm",
  //   pictureSrc: img16e,
  //   description: "2016",
  //   orientation: "h"
  // },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/16a/data16a.js